import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-heart',
  standalone: true,
  template: `
    <svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      [class]="className"
    >
      <path
        d="M29.0008 12.4398L30.0013 13.3358L31.002 12.44C33.5727 10.1388 36.9272 8.90962 40.3761 9.00502C43.825 9.10043 47.1063 10.5132 49.5459 12.953L49.546 12.9531C51.9835 15.3903 53.3965 18.6676 53.4952 22.1131C53.5935 25.5449 52.3807 28.8846 50.1044 31.4533L29.9967 51.5895L9.89362 31.4532C7.61449 28.8831 6.40044 25.5404 6.49979 22.1057C6.59954 18.6575 8.01559 15.3782 10.4572 12.9411C12.8989 10.5041 16.1808 9.09427 19.6293 9.00103C23.0778 8.90779 26.4311 10.1382 29.0008 12.4398Z"
        [attr.fill]="fill || '#FFFFFF'"
        [attr.stroke]="stroke || '#FFA500'"
        stroke-width="3"
      />
    </svg>
  `,
})
export class HeartComponent {
  @Input() fill?: string;
  @Input() stroke?: string;
  @Input() className?: string;
}